export default "__VITE_ASSET__ce75dd38__"